import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import {
  FlowReviewerData,
  FlowReviewerDelete,
  OperFlowService,
} from '../../../../services/types/Flow';
import { ConfirmModal, LinkButton } from '../../../../shared/components';
import MainContext from '../../../App/MainProvider/context';

interface Props {
  data: FlowReviewerData[] | null;
  operFlowService: OperFlowService;
  reloadReviewers: () => void;
}

const ReviewersTable: React.FC<Props> = ({ data, operFlowService, reloadReviewers }) => {
  const { t } = useTranslation();
  const { service } = useContext(MainContext);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState({
    userId: null,
    flowId: null,
  } as FlowReviewerDelete);

  const deleteReviewer = () => {
    if (userToDelete.flowId && userToDelete.userId) {
      service(() => operFlowService.removeReviewers(userToDelete), {
        callback: () => {
          setShowConfirmModal(false);
          reloadReviewers();
        },
      });
    }
  };

  const renderRows = () => {
    if (!data) {
      return null;
    }
    return data.map((x, i) => (
      <tr key={`feedbackTable_tr${i.toString()}`}>
        <td>{x.user}</td>
        <td className="reviewers-table">
          {x.provideFeedback ? (
            <FontAwesomeIcon className="feedback-button ok" fixedWidth icon="check-circle" />
          ) : (
            <FontAwesomeIcon className="feedback-button cancel" fixedWidth icon="times-circle" />
          )}
        </td>
        <td className="reviewers-table">
          <div>
            {x.canEdit ? (
              <LinkButton
                key={`delete_approver_${x.userId}`}
                onClick={() => {
                  setShowConfirmModal(true);
                  setUserToDelete({ userId: x.userId, flowId: x.flowId });
                }}
                icon="trash-alt"
                className="reviewers-table"
                noFit
              />
            ) : (
              <FontAwesomeIcon className="feedback-button ban" fixedWidth icon="ban" />
            )}
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <div className="history-content flow-history mb-0 table-responsive">
      <Table responsive>
        <thead>
          <tr>
            <th className="reviewers-table">{t('reviewerName')}</th>
            <th className="reviewers-table">{t('providedFeedback')}</th>
            <th className="reviewers-table">{t('deleteReviewer')}</th>
          </tr>
        </thead>
        <tbody>{renderRows()}</tbody>
      </Table>
      <ConfirmModal
        visible={showConfirmModal}
        buttonText={t('confirm')}
        setVisible={setShowConfirmModal}
        action={() => deleteReviewer()}
      >
        {t('confirmDeleteReviewerMessage')}
      </ConfirmModal>
    </div>
  );
};

export default ReviewersTable;
